/* eslint-disable react/no-children-prop */

/**
 * Utilites for the Draft JS powered QueryInput component
 */
import React from 'react'
// import _ from 'lodash'
import {
  // Editor,
  // EditorState,
  // ContentState,
  SelectionState,
  // Entity,
  Modifier,
  // convertFromRaw,
  // convertToRaw,
  // AtomicBlockUtils,
  // CompositeDecorator,
} from 'draft-js'
import { List } from 'immutable'
// import {
//   stripSmartQuotes
// } from 'utils/editorInputUtils'

const DELIMITER = ':'
const DECORATOR_DELIMITER = ','

function _occupySlice (targetArr/* Array<?string>*/, start, end, componentKey) {
  for (let ii = start; ii < end; ii++) {
    if (targetArr[ii]) {
      targetArr[ii] = targetArr[ii] + DECORATOR_DELIMITER + componentKey // eslint-disable-line
    } else {
      targetArr[ii] = componentKey // eslint-disable-line no-param-reassign
    }
  }
}
//
// function _canOccupySlice (decorations, start, end) {
//   for (var ii = start; ii < end; ii++) {
//     if (decorations[ii] != null) {
//       return false
//     }
//   }
//   return true
// }

/**
 * Support for Nested Decorators (vs. single-decorator-only default
 * behavior of CompositeDecorator
 * https://github.com/facebook/draft-js/issues/246
 *
 * NOTE: Modified to work with master-branch draft-js:
 *       (entity store moved from Singleton object into contentState)
 */
export class NestableDecorator {
  constructor(decorators) {
    // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.
    this.decorators = decorators.slice()

    // We must cache the components, otherwise every time try get a component
    // using getComponentForKey would be a new object, that makes draft buggy
    this.componentCache = {}
  }

  getDecorations(block, contentState) { // return immutable List
    const decorations = new Array(block.getText().length).fill(null)
    this.decorators.forEach((decorator, ii) => {
      let counter = 0
      const strategy = decorator.strategy
      const callback = (start, end) => {
        // if (_canOccupySlice(decorations, start, end)) {
        _occupySlice(decorations, start, end, ii + DELIMITER + counter)
        counter++
        // }
      }
      strategy(block, callback, contentState)
    })
    return List(decorations) // eslint-disable-line new-cap
  }

  getComponentForKey(key) {
    // console.log('getting componentkey',key)
    if (this.componentCache[key]) return this.componentCache[key]
    const components = key.split(DECORATOR_DELIMITER)
      .map(k => parseInt(k.split(DELIMITER)[0], 10))
      .map(k => this.decorators[k].component)

    this.componentCache[key] = (props) => {
      // composite component
      return components.reduce((children, Outer) => (
        <Outer
          { ...props }
          children={ children }
        />
      ), props.children)
    }
    return this.componentCache[key]
  }

  getPropsForKey(key) {
    const pps = key.split(DECORATOR_DELIMITER)
      .map(k => parseInt(k.split(DELIMITER)[0], 10))
      .map(k => this.decorators[k].props)
    return Object.assign({}, ...pps)
  }
}


/**
 * Return a new SelectionState instance for the passed text range offsets, and
 * for the specified ContentBlock key
 * @method getNewSelectionStateForRange
 * @param  {number}                      startOffset
 * @param  {number}                      endOffset
 * @param  {string?}                     blockKey
 * @return {SelectionState}
 */
export function getNewSelectionStateForRange (startOffset, endOffset, blockKey) {
  return new SelectionState({
    anchorKey: blockKey,
    anchorOffset: startOffset,
    focusKey: blockKey,
    focusOffset: endOffset
  })
}


/**
 * Remove all entities from the passed contentBlock
 * @method stripEntitiesFromContentBlock
 * @param  {ContentState}                       contentState
 * @param  {ContentBlock}                       contentBlock
 * @return {ContentState}
 */
export function stripEntitiesFromContentBlock (contentState, contentBlock) {
  contentState = Modifier.applyEntity(
    contentState,
    getNewSelectionStateForRange(0, contentBlock.getLength(), contentBlock.getKey()),
    null
  )
  // Purge old entities from contentState's entity storage cache
  // TODO not sure if this is needed, but seems like reasonable cleanup
  // contentState = contentState.set(
  //   'entityMap',
  //   contentState.getEntityMap().clear()
  // )
  return contentState
}

/**
 * Replace all text in a ContentBlock with the passed value
 * @method replaceContentBlockText
 * @param  {ContentState}                       contentState
 * @param  {ContentBlock}                       contentBlock
 * @return {ContentState}
 */
export function replaceContentBlockText (contentState, contentBlock, _replaceContentBlockText) {
  contentState = Modifier.replaceText(
    contentState,
    getNewSelectionStateForRange(0, contentBlock.getLength(), contentBlock.getKey()),
    _replaceContentBlockText
  )
  return contentState
}

// Sample with smartquotes and double-prime in place of quotes:
/*
alert tcp $EXTERNAL_NET any -> $HOME_NET 7547 (msg:“SOAP RCE NewNTPServer Exploit Inbound”; content:"POST"; content:"/UD/act?1″; content:"urn:dslforum-org:service:Time:1#SetNTPServers"; threshold:type limit, track by_dst, count 1, seconds 60; flow:established,to_server; classtype:attempted-admin; gid:356173995; sid:70044068; rev:6;)
*/


export const defangRegex = /(?:\[\.\])+/g

export const domainSanitizer = (str) => {
  return str.replace(defangRegex, '.')
}
